<section class="header">
  @if (model[0]) {
    @for (cell of model[0]; track cell) {
      <div class="cell">
        {{ cell.date | date: 'E' }}
      </div>
    }
  }
</section>

@for (row of model; track trackRow($index, row)) {
  <div class="row">
    @for (cell of row; track trackCell($index, cell)) {
      <div class="col" (click)="addEvent(cell.date)">
        <div class="date" (click)="dateClicked(cell.date); $event.stopPropagation()">
          {{ cell.date | date: (cell.monthLabel ? 'MMM d' : 'd') }}
        </div>
        <div class="events">
          @for (event of cell.events | slice: 0 : eventsPerCell; track event) {
            <div
              class="event"
              [style]="eventStyles.get(event)"
              (click)="showDetails(event); $event.stopPropagation()"
              [blazeTooltip]="event.title"
              matTooltipPosition="above"
              data-cy="Calendar:Event"
            >
              <div class="title" data-cy="Calendar:Event:Title">{{ event.title || '&nbsp;' }}</div>
              <div class="actions">
                @if (isEditEnabled) {
                  <button
                    type="button"
                    class="action-button edit"
                    (click)="editEvent(event); $event.stopPropagation()"
                    data-cy="Calendar:Event:Edit"
                  >
                    <mat-icon svgIcon="icon_edit_16" />
                  </button>
                }
                @if (isDeleteEnabled) {
                  <button
                    type="button"
                    class="action-button remove"
                    (click)="removeEvent(event); $event.stopPropagation()"
                    data-cy="Calendar:Event:Delete"
                  >
                    <mat-icon svgIcon="icon_trash_16" />
                  </button>
                }
              </div>
            </div>
          }
          @if (cell.events.length > eventsPerCell) {
            <div>
              <a
                class="more"
                (click)="showDay(cell, $event); $event.stopPropagation()"
                data-cy="Calendar:Event:More"
                >More</a
              >
            </div>
          }
        </div>
      </div>
    }
  </div>
}
<div class="row placeholder">
  <div class="col placeholder">
    <div class="date">1</div>
    <div class="events">
      <div class="event" [style]="eventStyles.get(undefined)"> title </div>
    </div>
  </div>
</div>

<ng-template cdkPortal #popupTemplate="cdkPortal">
  <div class="popup" [style]="componentStyles" data-cy="Calendar:DayPopup">
    <div class="bar">
      <span class="title">{{ selectedCell?.date | date: 'MMM d' }}</span>
      <button class="close" (click)="closeDay()" data-cy="Calendar:DayPopup:Close">
        <mat-icon svgIcon="close" />
      </button>
    </div>
    <blaze-scroller class="scroller">
      <div class="content">
        @for (event of selectedCell?.events; track event) {
          <div class="event" (click)="showDetails(event)" data-cy="Calendar:DayPopup:Event">
            <div class="time" data-cy="Calendar:DayPopup:Event:Time">
              {{ event.startDate | date: timePipeFormat | lowercase }}
            </div>
            <div class="name">
              <span
                class="text"
                [style]="eventStyles.get(event)"
                data-cy="Calendar:DayPopup:Event:Title"
              >
                {{ event.title }}
                <div class="actions">
                  @if (isEditEnabled) {
                    <button
                      type="button"
                      class="action-button edit"
                      (click)="editEvent(event); $event.stopPropagation()"
                      data-cy="Calendar:DayPopup:Event:Edit"
                    >
                      <mat-icon svgIcon="icon_edit_16" />
                    </button>
                  }
                  @if (isDeleteEnabled) {
                    <button
                      type="button"
                      class="action-button remove"
                      (click)="removeEvent(event); $event.stopPropagation()"
                      data-cy="Calendar:DayPopup:Event:Delete"
                    >
                      <mat-icon svgIcon="icon_trash_16" />
                    </button>
                  }
                </div>
              </span>
            </div>
          </div>
        }
      </div>
    </blaze-scroller>
  </div>
</ng-template>

<div #overlayTarget></div>
